import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { NotaAuditoriaExecucaoService } from "../../../../../services/nota-auditoria-execucao.service";
import { SharedService } from "../../../../../services/shared.service";
import { AuthService } from "../../../../../services/auth.service";
import { MatTableDataSource } from "@angular/material/table";
import { INotaItemAuditoriaExecucaoModel } from "../../../../../models/nota-item-auditoria-execucao.model";
import { INotaAuditoriaExecucaoModel } from "../../../../../models/nota-auditoria-execucao.model";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import Swal from "sweetalert2";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { angularEditorConfig } from "../../../../../shared/util/angularEditorConfig";
import { IItemSolicitacaoTecnicaModel } from "../../../../../models/item-solicitacao-tecnica.model";
import {
  OsaExecucaoModalResponderItemSolicitacaoComponent
} from "../../../osa-execucao-aba-solicitacao-tecnica/modal-responder-item-solicitacao/osa-execucao-modal-responder-item-solicitacao.component";
import {
  OsaExecucaoModalAvaliarRespostaComponent
} from "../../../osa-execucao-aba-solicitacao-tecnica/modal-avaliar-resposta/osa-execucao-modal-avaliar-resposta.component";
import {
  ModalJustificativaComponent
} from "../../../../../shared/components/modal-justificativa/modal-justificativa.component";
import {
  ModalResponderItemNotaAuditoriaExecucaoComponent
} from "../modal-responder-item-nota/modal-responder-item-nota-auditoria-execucao.componet";
import {
  ModalAvaliarProrrogacaoNotaAuditoriaComponent
} from "../modal-avaliar-prorrogacao-nota-auditoria/modal-avaliar-prorrogacao-nota-auditoria.component";
import {
  ModalAvaliarRespostaItemNotaComponent
} from "../modal-avaliar-resposta-item-nota/modal-avaliar-resposta-item-nota.component";
import { ModalIncluirNotaExecucaoComponent } from "../modal-incluir-nota/modal-incluir-nota-execucao.component";

@Component({
  selector: 'app-modal-responder-nota-auditoria-execucao',
  templateUrl: './modal-responder-nota-auditoria-execucao.componet.html',
  styleUrls: ['./modal-responder-nota-auditoria-execucao.componet.scss']
})
export class ModalResponderNotaAuditoriaExecucaoComponent implements OnInit, AfterViewInit{

  public editorConfig: AngularEditorConfig = angularEditorConfig(
    "Digite a descrição",
    "200px",
    "100%"
  );
  dataAtual = new Date();
  public dataSourceItems = new MatTableDataSource<INotaItemAuditoriaExecucaoModel>([]);
  public visualizar: boolean;
  public titulo: string = "";
  public submitted: boolean;
  public dataHoje: Date = this.truncateDate(new Date());
  public model: INotaAuditoriaExecucaoModel = {} as INotaAuditoriaExecucaoModel;
  public numeroST: string;
  public dataPrazoLimite: Date;
  public acaoCancelarItem: boolean;
  public acaoResponder: Boolean;
  public acaoAvaliar: Boolean;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("maxLengthEditor") private angularEditor: any;

  constructor(
    private fb: FormBuilder,
    public matDialog: MatDialog,
    public notaAuditoriaExecucaoService: NotaAuditoriaExecucaoService,
    private sharedService: SharedService,
    private dialogRef: MatDialogRef<ModalResponderNotaAuditoriaExecucaoComponent>,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    if (data?.id) {
      this.model.id = data.id;
    }

    this.visualizar = data?.visualizar;
    this.titulo = data?.titulo;
    this.model.status = data?.status;
    this.model.documentoAssociado = data?.documentoAssociado;
    this.numeroST = data?.numeroST;
    this.dataPrazoLimite = this.truncateDate(data?.dataLimite);
    this.acaoCancelarItem = data?.acaoCancelarItem;
    this.acaoResponder = data?.responder;
    this.acaoAvaliar = data?.avaliar;
  }


  public incluirNotaAuditoria: FormGroup = this.fb.group({
    assunto: ["", Validators.required],
    descricao: ["", Validators.required],
    nomeResponsavel: ["", Validators.required],
    cargoResponsavel: ["", Validators.required],
    prazoResposta: ["", [Validators.required, this.dateRangeValidator.bind(this)]],
  });

  ngOnInit(): void {
    this.dataSourceItems.paginator = this.paginator;
    this.dataSourceItems.sort = this.sort;
    this.dataSourceItems.sortingDataAccessor = this.sortingDataAccessor;

    // Carrega os dados se houver um ID
    if (this.model?.id) {
      this.obterPorId();
    }
  }

  dateRangeValidator(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) return null;

    const selectedDate = this.truncateDate(new Date(control.value));

    if (selectedDate < this.dataHoje) {
      return { dataMenorHoje: true };
    }
    return null;
  }
  ngAfterViewInit() {
    function maxLengthAngularEditor(e: any) {
      var element = e.target as HTMLTextAreaElement;
      let permitirTeclas =
        e.key !== "Backspace" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight";
      if (element.innerHTML.length === 2000 && permitirTeclas) {
        e.preventDefault();
      }
    }

    this.angularEditor?.textArea?.nativeElement.addEventListener(
      "keydown",
      maxLengthAngularEditor,
      false
    );
  }
  public obterPorId(): void {
    if (!this.model?.id) {
      return;
    }

    this.notaAuditoriaExecucaoService.obterPorId(this.model.id).then((res) => {

      if (res.sucesso && res.dados) {
        const dados = res.dados;
        // Popula a tabela de itens
        this.dataSourceItems = new MatTableDataSource<INotaItemAuditoriaExecucaoModel>(
          dados.item || []
        );

        // Popula os campos do formulário
        this.incluirNotaAuditoria.patchValue({
          prazoResposta: dados.prazo ? new Date(dados.prazo) : null,
          assunto: dados.assunto,
          descricao: dados.descricao,
          nomeResponsavel: dados.nomeResponsavel,
          cargoResponsavel: dados.cargoResponsavel
        });

        // Atualiza o model
        this.model.id = dados.id;
        this.model.numero = dados.numero;
        this.model.status = dados.status;
        this.model.assunto = dados.assunto;
        this.model.descricao = dados.descricao;
        this.model.prazo = dados.prazo;
        this.model.nomeResponsavel = dados.nomeResponsavel;
        this.model.cargoResponsavel = dados.cargoResponsavel;
        this.model.documentoAssociado = dados.documentoAssociado;
        this.model.unidadeGestoraSigla = dados.unidadeGestoraSigla;
        this.model.DataLimite = dados.DataLimite;
        this.model.item = dados.item;
        this.model.prorrogarNotaAuditoriaExecucao = dados.prorrogarNotaAuditoriaExecucao;
        this.model.responsavelIdCanc = dados.responsavelIdCanc;
        this.model.responsavelCanc = dados.responsavelCanc;
        this.model.dataHoraCanc = dados.dataHoraCanc;
        this.model.justificativa = dados.justificativa;

        // Configura paginação e ordenação
        this.dataSourceItems.paginator = this.paginator;
        this.dataSourceItems.sort = this.sort;


        // Desabilita campos se for visualização
        if (this.visualizar) {
          this.incluirNotaAuditoria.disable();
        } else {
          this.incluirNotaAuditoria.enable();
        }

      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem?.descricao || 'Registro não encontrado',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    }).catch((err) => {
      console.error('Erro:', err);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem?.descricao || 'Erro ao buscar dados',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    });
  }

  isStatusAvaliacaoVazio(statusAvaliacao: any): boolean {
    return !statusAvaliacao || statusAvaliacao === null || statusAvaliacao === undefined;
  }


  formatarTooltipAvaliacao(element: any): string {
    const data = element?.dataHoraAvaliacao
      ? new Date(element.dataHoraAvaliacao).toLocaleDateString('pt-BR')
      : 'Data não informada';

    const nome = element?.responsavelNomeAvaliacao || 'Avaliador desconhecido';
    const comentario = element?.comentarioAvaliacao || 'Sem comentário';

    return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
  }


  public modalResponderItem(element?: INotaItemAuditoriaExecucaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component-resposta";
    dialogConfig.width = "60%";
    dialogConfig.height = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Responder Constatação",
      id: element?.id,
      solicitacaoTecnicaId: this.model.id,
      responder: true,
      numeroNotaAuditoria: this.model?.numero,
      visualizar: false,
      documentoAssociado: this.sharedService.getNumeroOsa(),
      resposavel: this.model.nomeResponsavel,
      element
    };
    const modal = this.matDialog.open(
      ModalResponderItemNotaAuditoriaExecucaoComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
      this.obterPorId();
    });
  }

  public modalAvaliarItem(element?: IItemSolicitacaoTecnicaModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component-avaliacao-item";
    dialogConfig.width = "50vw";
    dialogConfig.maxHeight = "85vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: element?.id
    };
    const modal = this.matDialog.open(
      ModalAvaliarRespostaItemNotaComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
      this.obterPorId();
    });
  }
  formatarTooltipCanc(element: any): string {

    const data = element?.dataHoraCanc
      ? new Date(element.dataHoraCanc).toLocaleDateString('pt-BR')
      : 'Data não informada';

    const nome = element?.responsavelNomeCanc || 'Usuário desconhecido';
    const comentario = element?.justificativa || 'Sem comentário';

    return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
  }

  public prorrogarPrazo() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component-prorrogar-nota";
    dialogConfig.width = '45vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { prorrogarPrazo: true };

    const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.processarAfterClosedModalProgrrogacaoPrazo(data);
      }
    });
  }

  private processarAfterClosedModalProgrrogacaoPrazo(data: any) {
    this.notaAuditoriaExecucaoService.prorrogarPrazo(this.model.id, data).then((res) => {

      if (res.sucesso) {
        this.mostraMensagemSucesso(res.mensagem.descricao);
        this.dialogRef.close();
      } else {
        this.mostraMensagemAlerta(res.mensagem.descricao);
      }
    }).catch((err) => {
      this.mostraMensagemErro(err?.mensagem?.descricao);
    })
  }
  private mostraMensagemSucesso(descricao: string): void {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      text: descricao,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  }

  private mostraMensagemAlerta(descricao: string): void {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "warning",
      text: descricao,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  }

  private mostraMensagemErro(descricao: string): void {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "error",
      text: descricao,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  }

  public cancelar() {
    this.dialogRef.close();
  }
  public modalVisualizarItem(element?: IItemSolicitacaoTecnicaModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component-resposta";
    dialogConfig.width = "60%";
    dialogConfig.height = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Visualizar Resposta Nota de Auditoria",
      id: element?.id,
      solicitacaoTecnicaId: this.model.id,
      responder: false,
      numeroNotaAuditoria: this.model?.numero,
      visualizar: true,
      documentoAssociado: this.sharedService.getNumeroOsa(),
      resposavel: this.model.nomeResponsavel,
      element
    };
    const modal = this.matDialog.open(
      ModalResponderItemNotaAuditoriaExecucaoComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
      this.obterPorId();
    });
  }


  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "ug":
        return item?.unidadeGestora?.text;
      case "responsavel":
        return item?.responsavel?.text;
      case "tituloItem":
        return item?.titulo;
      case "numero":
        return item?.numero;
      case "status":
        return item?.status?.descricao;
      default:
        return item[property];
    }
  };
  private truncateDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
}
